import { render, staticRenderFns } from "./EntityEditor.vue?vue&type=template&id=70710875"
import script from "./EntityEditor.vue?vue&type=script&lang=js"
export * from "./EntityEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports